import { sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';

import { getUserInfo, hasAdminAuth } from "api/commonUtil";
import BasicButton from "components/button/BasicButton";
import BranchAddModModal from "./BranchAddModModal";
import BranchAreaListModal from "./BranchAreaListModal";
import BranchHolidayListModal from "./BranchHolidayListModal";
import { modConfirm, saveConfirm } from "js/common";

function BranchList() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터 (신청자: 로그인 사용자, 날짜: 해당월 1일 ~ 오늘)
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이징 정보
	const [ pagingInfo, setPagingInfo ] = useState({});
	// 등록 팝업
	const [ isOpenAddModal, setIsOpenAddModal] = useState(false);
	// 수정 팝업
	const [ isOpenModModal, setIsOpenModModal] = useState(false);
	// 수정할 데이터
	const [ modInitData, setModInitData ] = useState({});
	// 권역 팝업
	const [ isOpenAreaModal, setIsOpenAreaModal] = useState(false);
	// 권역 팝업 데이터
	const [ areaInitData, setAreaInitData ] = useState({});
	// 휴일 팝업
	const [ isOpenHolidayModal, setIsOpenHolidayModal] = useState(false);
	// 휴일 팝업 데이터
	const [ holidayInitData, setHolidayInitData ] = useState({});

	//검색 조건
	const conditionList = [
		hasAdminAuth() ?
		{
			title : "지점 ID",
			col : "branchId",
			type : "input",
		} : null,
		hasAdminAuth() ?
		{
			title : "지점 이름",
			col : "branchName",
			type : "input",
		} : null,
		hasAdminAuth() ?
		{
			title : "활성화 여부",
			col : "activationYn",
			type : "select",
			option : [
				{label : "전체", value : ""},
				{label : "활성", value : "true"},
				{label : "비활성", value : "false"},
			],
		} : null,
	];
	
	
	// 수정 팝업
	const modData = async (data) => {
		setModInitData({branchId : data.branchId});
		setIsOpenModModal(true);
	}
	// 권역 팝업
	const openBranchArea = async(data) => {
		setAreaInitData({branchId: data.branchId, branchName: data.branchName});
		setIsOpenAreaModal(true);
	}
	// 휴일 팝업
	const openHoliday = async(data) => {
		setHolidayInitData({branchId: data.branchId, branchName: data.branchName});
		setIsOpenHolidayModal(true);
	}
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "지점ID", col : "branchId", notView: true },
		{ header : "지점 이름", col : "branchName", cellWidth : "100" },
		{ header : "연락처", col : "branchContactInfo", cellWidth : "100" },
		// { header : "활성화 여부", col : "activationYn", cellWidth: "50"},
		{ header : "활성화 여부", col : "activationYnStr", cellWidth : "50" },
		{ header : "수정", col: "branchId", cellWidth : "30", type : "modButton", onClick: modData},
		{ header : "권역", col: "branchId", cellWidth : "30", type : "modButton", label: "관리", onClick: openBranchArea},
		{ header : "휴일", col: "branchId", cellWidth : "30", type : "modButton", label: "관리", onClick: openHoliday},
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			const initCond = {activationYn: "true"};
			//초기 검색 조건
			setInitialCondition(initCond);
			searchList(initCond);
		};

		initData();

	}, []);

	//목록 조회
	const searchList = async (cond = {}, isRefresh = false) => {
		if(!hasAdminAuth()) {
			cond.branchId = getUserInfo().branchId;
		}
		let result = await sendGet("/api/mgmt/branch", cond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			const dataList = result.data.list;
			dataList.forEach(data => {
				if(data.activationYn) {
					data.activationYnStr = "Y";
				} else {
					data.activationYnStr = "N";
				}
			});
			setDataList(result.data.list);
			setPagingInfo({...result.data, searchFnc : searchList, searchCond : cond});
		}
	}

	const addBranch = async (data) => {
		if(!saveConfirm()) return;

		const result = await sendPost("/api/mgmt/branch", data);
		if(result.respCode === "SUCCESS") {
			alert("등록되었습니다.");
			searchList(condition);
			setIsOpenAddModal(false);
		}
	}
	const modBranch = async (data) => {
		if(!modConfirm()) return;

		if(data.activationYn === true) delete data.activationFalseReason;
		if(data.deliveryYn === true) delete data.deliverySuspensionReason;
		if(data.pickUpYn === true) delete data.pickUpSuspensionReason;

		const result = await sendPut("/api/mgmt/branch/" + data.branchId, data);
		if(result.respCode === "SUCCESS") {
			alert("수정되었습니다.");
			searchList(condition);
			setIsOpenModModal(false);
		}

	}


	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
				<BasicButton
					label="추가"
					className="btn-add"
					onClick={() => setIsOpenAddModal(true)}
				/>
				{/* <BasicButton
					label="삭제"
					className="btn-del"
					disabled={selectedAdminList.length === 0}
					// selectRow={selectedAdminList}
					onClick={deleteAdmin}
				/> */}
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				rowClick={"checkbox"}
				pagingInfo={pagingInfo}
			/>
			{/* 지점 등록 */}
			<BranchAddModModal
				isOpen={isOpenAddModal}
				initData={{}}
				returnData={addBranch}
				onClose={()=> setIsOpenAddModal(false)}
				title="지점 등록"
			/>
			{/* 지점 수정 */}
			<BranchAddModModal
				isOpen={isOpenModModal}
				initData={modInitData}
				returnData={modBranch}
				onClose={()=> {setIsOpenModModal(false); setModInitData({});}}
				title="지점 수정"
			/>
			{/* 권역 관리 */}
			<BranchAreaListModal
				isOpen={isOpenAreaModal}
				initData={areaInitData}
				onClose={()=> {setIsOpenAreaModal(false); setAreaInitData({});}}
				title="지점 권역 수정"
			/>
			{/* 휴일 관리 */}
			<BranchHolidayListModal
				isOpen={isOpenHolidayModal}
				initData={holidayInitData}
				onClose={()=> {setIsOpenHolidayModal(false); setHolidayInitData({});}}
				title="지점 휴일 수정"
			/>

		</div>
	);
}

export default BranchList;